import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SectionHero from './SectionHero';
import SectionHowItWorks from './SectionHowItWorks';
import SectionPayback from './SectionPayback';
import SectionWhyChoose from './SectionWhyChoose';
import SectionContactCTA from './SectionContactCTA';

gsap.registerPlugin(ScrollTrigger);

const Home = () => {
  useEffect(() => {
    // Refresh ScrollTrigger on component mount
    ScrollTrigger.refresh();
    
    return () => {
      // Clean up ScrollTrigger instances on unmount
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <div className="overflow-hidden">
      <SectionHero />
      <SectionHowItWorks />
      <SectionPayback />
      <SectionWhyChoose />
      <SectionContactCTA />
    </div>
  );
};

export default Home;
